module.exports = __webpack_public_path__ + "img/picture_01.f151c820.jpg";